export default "__VITE_ASSET__1c31a008__"